import { ax } from './_ax';

const ERROR_CODES = [401];

const login = async (creds) => {
  const res = await ax.post('/login', creds);

  if (ERROR_CODES.includes(res.status)) {
    throw new Error(res.data.errorMessage);
  } else {
    localStorage.setItem('token', res.data.token);
  }
};
// Paths we are willing to preserve through a forced logout/login bounce. Keep
// this list tight to avoid an open-redirect surface. Add new entries only when
// the destination is a deep-link page reached via an authenticated link
// (e.g. an email link) and not a navigation that just happens to be protected.
const PRESERVE_PATH_PREFIXES = ['/intake/'];

const logout = async () => {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  const currentPath =
    (window.location && window.location.pathname + window.location.search) ||
    '';
  const shouldPreserve = PRESERVE_PATH_PREFIXES.some((prefix) =>
    currentPath.startsWith(prefix),
  );
  const next = shouldPreserve ? `?next=${encodeURIComponent(currentPath)}` : '';
  window.location = `/login${next}`;
  return true;
};
const register = (user) => ax.post('/register', user);
const updateCurrentUser = async (newData) => {
  const { uid, ...rest } = newData;
  const res = await ax.patch(`/users/${uid}`, rest);
  return res;
};
const forgotPassword = async (payload) => {
  const res = await ax.post('/forgot-password', payload);

  if (ERROR_CODES.includes(res.status)) {
    throw new Error(res.data.errorMessage);
  }
};

const resetPassword = async (payload) => {
  const res = await ax.post('/reset-password', payload);

  if (ERROR_CODES.includes(res.status)) {
    throw new Error(res.data.errorMessage);
  }
};

const authService = {
  login,
  logout,
  register,
  updateCurrentUser,
  forgotPassword,
  resetPassword,
};
export default authService;
